interface LoginErrorProps {
  error: string;
  onRetry: () => void;
  onClose: () => void;
  isVisible: boolean;
}

export default function LoginError({ error, onRetry, onClose, isVisible }: LoginErrorProps) {
  if (!isVisible) return null;

  const getErrorIcon = (errorMessage: string) => {
    if (errorMessage.includes('popup')) return '🔒';
    if (errorMessage.includes('network') || errorMessage.includes('internet')) return '🌐';
    if (errorMessage.includes('cancelled')) return '❌';
    return '⚠️';
  };

  const getErrorTitle = (errorMessage: string) => {
    if (errorMessage.includes('popup')) return 'Error de Autenticación';
    if (errorMessage.includes('network') || errorMessage.includes('internet')) return 'Error de Conexión';
    if (errorMessage.includes('cancelled')) return 'Login Cancelado';
    return 'Error Inesperado';
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md w-full mx-4 border border-white/20">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">{getErrorIcon(error)}</span>
          </div>
          <h3 className="text-xl font-bold text-[#2C4358] mb-2">
            {getErrorTitle(error)}
          </h3>
          <p className="text-[#85929e] text-sm leading-relaxed">
            {error}
          </p>
        </div>

        {/* Error Details */}
        <div className="bg-red-50 rounded-2xl p-4 mb-6 border border-red-200">
          <div className="flex items-start space-x-3">
            <span className="text-red-500 text-lg">💡</span>
            <div className="text-sm text-red-700">
              <p className="font-medium mb-1">Sugerencias:</p>
              <ul className="space-y-1 text-xs">
                <li>• Verifica tu conexión a internet</li>
                <li>• Asegúrate de permitir popups</li>
                <li>• Intenta con otro proveedor</li>
                <li>• Contacta soporte si persiste</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-[#e9ecef] text-[#2C4358] rounded-xl font-bold hover:bg-[#dee2e6] transition-colors"
          >
            Cerrar
          </button>
          <button
            onClick={onRetry}
            className="flex-1 py-3 px-4 bg-[#f7ebd6] text-[#2C4358] rounded-xl font-bold hover:bg-[#f0e0c0] transition-colors border border-[#f7ebd6]/50"
          >
            Reintentar
          </button>
        </div>
      </div>
    </div>
  );
} 